module.exports = __webpack_public_path__ + "static/media/bamba.4dc26266.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/squadBackgroundImg/bamba.jpg
// module id = 732
// module chunks = 0